import React from 'react';
import { useTranslation } from 'react-i18next';
import containerBackgroundImage from '../../assets/images/puffBRF.jpg';
import { Divider } from '../../components/Divider';
import { H2 } from '../../components/Heading';
import { LayoutFullsizeBackgroundImage } from '../../components/Layout/LayoutFullsizeBackgroundImage';
import { RouterLink } from '../../components/Link';
import { useLoginUrl } from '../../hooks/useLoginUrl';
import RegisterUserForm from './RegisterUserForm';

const RegisterUser = () => {
  const { t } = useTranslation();
  const loginUrl = useLoginUrl();

  return (
    <LayoutFullsizeBackgroundImage backgroundImageUrl={containerBackgroundImage}>
      <H2 as="h1">{t('register_user_h1')}</H2>
      <p>{t('register_user_ingress')}</p>
      <p className="color-alt text-small">{t('register_user_disclaimer')}</p>

      <RegisterUserForm />

      <p className="text-center">
        {t('register_user_integrity_policy_text_prefix')}{' '}
        <RouterLink to="/terms-of-use">{t('termsofuse_title')}</RouterLink>.{' '}
        {t('register_user_integrity_policy_text_suffix')}{' '}
        <RouterLink to="privacy-policy">{t('footer_link_privacy_policy_text')}</RouterLink>.
      </p>

      <Divider />

      <p className="text-center">
        {t('register_user_existing_account')}{' '}
        {loginUrl && <RouterLink to={loginUrl}>{t('header_login_button')}</RouterLink>}
      </p>
    </LayoutFullsizeBackgroundImage>
  );
};

export default RegisterUser;
